export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_11_loop.e309cda9.mp4";